export const environment = {
  production: true,
  buildId: '2687278582418341',
  configFile: 'config.json',
};
